var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "div" },
    [
      _c("v-tour", {
        attrs: {
          name: "pickupManagementTour",
          steps: _vm.tourSteps,
          callbacks: _vm.customCallbacks,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tour) {
              return _vm._l(tour.steps, function (step, index) {
                return tour.currentStep === index
                  ? _c(
                      "v-step",
                      {
                        key: index,
                        attrs: {
                          step: step,
                          "previous-step": tour.previousStep,
                          "next-step": tour.nextStep,
                          stop: tour.stop,
                          "is-first": tour.isFirst,
                          "is-last": tour.isLast,
                          labels: tour.labels,
                        },
                      },
                      [
                        [
                          _c(
                            "div",
                            { attrs: { slot: "actions" }, slot: "actions" },
                            [
                              _c(
                                "div",
                                [
                                  !tour.isFirst
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass: "tourBtn",
                                          attrs: { type: "is-small" },
                                          on: { click: tour.previousStep },
                                        },
                                        [_vm._v(" Previous step ")]
                                      )
                                    : _vm._e(),
                                  _vm.currentStep < _vm.tourSteps.length - 1
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass: "tourBtn",
                                          attrs: { type: "is-small" },
                                          on: { click: tour.nextStep },
                                        },
                                        [_vm._v(" Next step ")]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "tourBtn",
                                      attrs: { type: "is-small" },
                                      on: { click: tour.stop },
                                    },
                                    [_vm._v(" Finish tour ")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                      ],
                      2
                    )
                  : _vm._e()
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }